module.exports = __webpack_public_path__ + "static/media/gravure2.28f697a4.jpg";